import * as React from 'react';
import lifecyclered from "src/assets/images/lifecycle-red.png";
import lifecyclegreen from "src/assets/images/lifecycle-green.png";
import lifecycleyellow from "src/assets/images/lifecycle-yellow.png";
import lifecycleunknown from "src/assets/images/lifecycle-unknown.png";
import { isArray, isString } from "underscore";

const BomHealthIndicator = (props) => {
    const { bom_health_by_bom_id } = props;
    const getImageOnStatus = (status) => {
        if (status === 'low') {
            return lifecyclegreen;
        }
        if (status === 'med') {
            return lifecycleyellow;
        }
        if (status === 'high') {
            return lifecyclered;
        }
        if (status === 'unknown') {
            return lifecycleunknown;
        }
        return false;
    };
    return (
        <>
            {
                bom_health_by_bom_id !== undefined &&
                isArray(bom_health_by_bom_id) &&
                bom_health_by_bom_id.length > 0 &&
                bom_health_by_bom_id.map((v, i) => (
                    <li className="me-1" key={i}>
                        {getImageOnStatus(v.lifeCycleRisk.toLowerCase()) &&
                            <img className="me-2"
                                src={getImageOnStatus(v.lifeCycleRisk.toLowerCase())} alt={''} />
                        }
                        <span>{v.percentage} {v.lifeCycleRisk.toLowerCase() === 'med' ? 'Medium' : v.lifeCycleRisk.charAt(0).toUpperCase() + v.lifeCycleRisk.slice(1).toLowerCase()}</span>
                    </li>
                ))
            }
            {
                bom_health_by_bom_id !== undefined &&
                isString(bom_health_by_bom_id) &&
                <li className="me-1">
                    {getImageOnStatus(bom_health_by_bom_id.toLowerCase()) &&
                        <img className="me-2"
                            src={getImageOnStatus(bom_health_by_bom_id.toLowerCase())} alt={''} />
                    }
                    <span>Health</span>
                </li>
            }
        </>
    );
}

export default BomHealthIndicator;